import { type IconType } from "@clipboard-health/ui-components";
import { type Theme } from "@mui/material/styles";

import { type PaymentsListItem } from "../types/PaymentsListItem";
import { isReversalPaymentItem } from "./isReversalPaymentItem";

export function getPayoutStatusText(item: PaymentsListItem): string {
  if (isReversalPaymentItem(item)) {
    return "Reversal";
  }

  switch (item.attributes.payoutStatus) {
    case "paid":
    case undefined: {
      return "Paid";
    }

    case "pending": {
      return "In transit";
    }

    case "failed": {
      return "Failed payout";
    }

    default: {
      return item.attributes.payoutStatus satisfies never;
    }
  }
}

export function getPayoutStatusColor(theme: Theme, item: PaymentsListItem): string {
  if (isReversalPaymentItem(item)) {
    return theme.palette.intent?.warning.text ?? "";
  }

  switch (item.attributes.payoutStatus) {
    case "paid":
    case undefined: {
      return theme.palette.intent?.success.text ?? "";
    }

    case "pending": {
      return theme.palette.intent?.neutral.text ?? "";
    }

    case "failed": {
      return theme.palette.intent?.error.text ?? "";
    }

    default: {
      return item.attributes.payoutStatus satisfies never;
    }
  }
}

export function getPayoutStatusIcon(item: PaymentsListItem): IconType {
  if (isReversalPaymentItem(item)) {
    return "swap-horizontal";
  }

  switch (item.attributes.payoutStatus) {
    case "paid":
    case undefined: {
      return item.attributes.payoutMethod === "instant" ? "bolt-filled" : "checkmark-filled";
    }

    case "pending": {
      return "clock-filled";
    }

    case "failed": {
      return "triangle-exclamation";
    }

    default: {
      return item.attributes.payoutStatus satisfies never;
    }
  }
}

export function getPayoutStatusBackgroundColor(theme: Theme, item: PaymentsListItem): string {
  if (isReversalPaymentItem(item)) {
    return theme.palette.intent?.warning.background ?? "";
  }

  switch (item.attributes.payoutStatus) {
    case "paid":
    case undefined: {
      return theme.palette.intent?.success.background ?? "";
    }

    case "pending": {
      return theme.palette.intent?.neutral.background ?? "";
    }

    case "failed": {
      return theme.palette.intent?.error.background ?? "";
    }

    default: {
      return item.attributes.payoutStatus satisfies never;
    }
  }
}
